__turbopack_context__.v({
  "body": "modal-module__rgMdaG__body",
  "close": "modal-module__rgMdaG__close",
  "full": "modal-module__rgMdaG__full",
  "header": "modal-module__rgMdaG__header",
  "lg": "modal-module__rgMdaG__lg",
  "md": "modal-module__rgMdaG__md",
  "modal": "modal-module__rgMdaG__modal",
  "modalIn": "modal-module__rgMdaG__modalIn",
  "overlay": "modal-module__rgMdaG__overlay",
  "sm": "modal-module__rgMdaG__sm",
  "xl": "modal-module__rgMdaG__xl",
});
